var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5113 14.6782H16.4635C16.4635 14.6782 21.1535 19.2107 22.2996 20.4583C23.4456 21.7059 21.8209 23.142 20.6748 22.1991C19.5288 21.2561 14.6782 16.4635 14.6782 16.4635V15.5113L14.3211 15.1543C13.0119 16.3445 11.2266 17.0586 9.32227 17.0586C5.03753 17.0586 1.58594 13.607 1.58594 9.32227C1.58594 5.03753 5.03753 1.58594 9.32227 1.58594C13.607 1.58594 17.0586 5.03753 17.0587 9.32227C17.0587 11.2266 16.3445 13.0119 15.1543 14.3211L15.5113 14.6782ZM9.30971 15.5921C12.7794 15.5921 15.5921 12.7794 15.5921 9.30971C15.5921 5.84006 12.7794 3.02734 9.30971 3.02734C5.84006 3.02734 3.02734 5.84006 3.02734 9.30971C3.02734 12.7794 5.84006 15.5921 9.30971 15.5921Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.d10ef411.svg";
export { ForwardRef as ReactComponent };